/* eslint-disable react/prop-types */
import React from 'react'

import { Typography, Grid, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import { IApplication } from '../../model/Applications'
import MikeAppIcon, {
  AppIconName
} from '@mike/mike-shared-frontend/mike-icon/MikeAppIcon'
import { appIconName, projectQueryParameter } from './configuration'

interface IProps {
  application: IApplication
  projectId: string
  linkToRootUrl: boolean
  tenantId: string
  disabled?: boolean
}

const StyledButton = styled(Button)<{ href?: string; target?: string }>(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: '12px',
    boxShadow: '0px 4px 2px rgba(0, 0, 0, 0.05)',
    height: theme.spacing(10),
    width: theme.spacing(10),
    transition: 'all 0.15s ease-in',
    '&:hover': {
      transform: 'translateY(-2px)',
      backgroundColor: theme.palette.secondary.light,
      boxShadow: '0px 6px 2px rgba(0, 0, 0, 0.05)'
    }
  })
)

const StyledAppName = styled(Grid)(({ theme }) => ({
  width: theme.spacing(16),
  paddingTop: theme.spacing(1),
  // Names wrap onto a second line before being ellipsed, so a single
  // unbreakable word has to be broken rather than spill past the tile.
  overflowWrap: 'anywhere'
}))

const MikeCloudApp = (props: IProps) => {
  const { application, projectId, linkToRootUrl, tenantId, disabled } = props

  const iconName: AppIconName =
    appIconName(application.name) !== undefined
      ? appIconName(application.name)
      : 'genericApp'

  const queryParameter = linkToRootUrl
    ? '?tenantId=' + tenantId
    : application.name === 'MIKE 3D World'
    ? projectQueryParameter('MIKE 3D World', projectId, tenantId)
    : projectQueryParameter(application.name, projectId, tenantId)

  return (
    <Grid container direction="column" alignItems="center" spacing={0}>
      <StyledButton
        disabled={disabled}
        target="_blank"
        href={application.url && application.url + queryParameter}
      >
        {iconName && application.name === 'MIKE Mine' ? (
          <img srcSet={`/icons/mike-mine.svg`} width={56} alt="ProductLogo" />
        ) : (
          <MikeAppIcon name={iconName} />
        )}
      </StyledButton>

      <StyledAppName
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item>
          {/* Capped at two lines; the tooltip carries the full name. */}
          <Tooltip title={application.name} enterDelay={500}>
            <Typography
              variant="body2"
              align="center"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}
            >
              {application.name}
            </Typography>
          </Tooltip>
        </Grid>
      </StyledAppName>
    </Grid>
  )
}

export default MikeCloudApp
